import {disableScroll, enableScroll} from '@/shared/helpers/helpers';

export class HeaderCatalog {
	private element: HTMLElement;
	private opener: HTMLButtonElement;
	private content: HTMLElement;
	private categories: NodeListOf<Element>;
	private isOpen: boolean = false;
	private readonly media = matchMedia('(hover: hover) and (pointer: fine)');
	private readonly activeClass: string = 'header-catalog--active';
	private readonly categoryActiveClass: string = 'header-catalog__item--active';

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.opener = this.element.querySelector('.header-catalog__button');
		this.content = this.element.querySelector('.header-catalog__content');
		this.categories = this.element.querySelectorAll('.header-catalog__item');

		this.init();
	}

	private setActiveCategory = (item): void => {
		item.classList.add(this.categoryActiveClass);
		this.categories.forEach((category) => {
			if (category !== item) category.classList.remove(this.categoryActiveClass);
		});
	};

	private handleCategoryMouseEnter = ({ target }): void => this.setActiveCategory(target);

	private handleCategoryTap = (event): void => {
		const { target, currentTarget } = event;
		if (target.closest('.header-catalog__category-link')) {
			event.preventDefault();
			this.setActiveCategory(currentTarget);
		}
	};

	private handleOpenerClick = () => {
		if (this.isOpen) this.close();
		else this.open();
	};

	private handleWindowClick = ({ target }): void => {
		if (!this.element.contains(target)) this.close();
	};

	private setTop = () => {
		const header = this.element.closest('.header-main');
		const headerBottom = header.getBoundingClientRect().bottom;
		this.element.style.setProperty('--content-top', `${headerBottom}px`);
	};

	public open = (): void => {
		this.setTop();
		this.isOpen = true;
		this.element.classList.add(this.activeClass);
		disableScroll();
		setTimeout(() => window.addEventListener('click', this.handleWindowClick), 100);
	};

	public close = (): void => {
		this.isOpen = false;
		this.element.classList.remove(this.activeClass);
		enableScroll();
		window.removeEventListener('click', this.handleWindowClick);
	};

	init = (): void => {
		this.categories.forEach((category) => {
			if (this.media.matches) category.addEventListener('mouseenter', this.handleCategoryMouseEnter);
			else category.addEventListener('click', this.handleCategoryTap);
		});
		this.opener.addEventListener('click', this.handleOpenerClick);
		this.setActiveCategory(Array.from(this.categories)[0]);
	};
}
